import type { SVGProps } from 'react';

export default function Attachments(
  props: SVGProps<SVGSVGElement>,
): JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7 10.9996V14.5996C7 17.2506 9.14903 19.3996 11.8 19.3996H12.2C14.851 19.3996 17 17.2506 17 14.5996V7.99961C17 6.12184 15.4778 4.59961 13.6 4.59961C11.7222 4.59961 10.2 6.12184 10.2 7.99961V14.2996C10.2 15.2385 10.9611 15.9996 11.9 15.9996C12.8389 15.9996 13.6 15.2385 13.6 14.2996V8.59961"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
